import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const sanityClient = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID || "j79fhl7e",
  dataset: process.env.REACT_APP_SANITY_DATASET || "production",
  apiVersion: "2024-01-01",
  useCdn: true,
});

const builder = imageUrlBuilder(sanityClient);

export function urlForImage(source, { width, height } = {}) {
  if (!source?.asset?._ref) return null;
  let img = builder.image(source).auto("format");
  if (width) img = img.width(width);
  if (height) img = img.height(height).fit("crop");
  return img.url();
}
